export default __webpack_public_path__ + "static/media/Path3548.eeb02461.svg";